import { render, staticRenderFns } from "./followDoc.vue?vue&type=template&id=7c98a8fd&scoped=true&"
import script from "./followDoc.vue?vue&type=script&lang=js&"
export * from "./followDoc.vue?vue&type=script&lang=js&"
import style0 from "./followDoc.vue?vue&type=style&index=0&id=7c98a8fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c98a8fd",
  null
  
)

export default component.exports